export type PublicationOptionValueModel = {
  id?: number,
  publication_option_id?: number,
  title?: string,
  value?: string,
}

const state = {
  id: null,
  publication_option_id: undefined,
  title: '',
  value: '',
}

export const requiredFields = [
  { key: 'publication_option_id' },
  { key: 'title' },
  { key: 'value' },
]

export default state
